import { useContext } from 'react';
import { ObjectAccessLoadingContext } from '../Context';

export const useObjectAccessLoading = () => {
  const reducer = useContext(ObjectAccessLoadingContext);

  return reducer;
};

export default useObjectAccessLoading;